import * as Sentry from '@sentry/browser';

import { checkDispatcher } from './dispatcher';

function beforeSend(event, hints) {
    const isFromMapbox = hints?.originalException?.stack?.includes('mapbox');

    const doNotSendEventConditions = [
        // Avoid confusing errors of MA VPN
        // Delete this when the VPN will be not used
        event?.request?.url?.indexOf('haussmann.meilleursagents.net') >= 0,

        // Prevent sending Safari known error of mapbox aborting multiple tiles fetch
        // See https://github.com/mapbox/mapbox-gl-js/issues/8480
        isFromMapbox && event?.message === 'AbortError: Fetch is aborted',
    ];

    if (doNotSendEventConditions.some(condition => condition)) {
        return null;
    }

    return event;
}

// eslint-disable-next-line import/no-mutable-exports
let sentry;

const dsn = global.MA.Config.SENTRY_DSN;
if (dsn && checkDispatcher('sentry_www')) {
    sentry = Sentry;
    Sentry.init({
        dsn,
        environment: MA.Config.SENTRY_ENVIRONMENT,
        ignoreErrors: [
            'Non-Error promise rejection captured with value: Object Not Found Matching',
            'Unable to send WA event HTTPError [403]',
            'Unable to send WA event HTTPError [undefined]',
            'Request failed with status code 403',
            'Connection problem during WA event (Network Error)',
            'Network Error',
            'Request aborted',
        ],
        beforeSend(event, hints) {
            try {
                return beforeSend(event, hints);
            } catch {
                return event;
            }
        },
    });
}

export default sentry;
